import { State } from 'model/State';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';

import { baseCurrencyApiUrl } from '../..';

export const getFromHamsClient = async (remainingPath: string, state: State) => {
  try {
    const config = selectHamsClientConfig(state);

    return (await hamsClient.get(`${baseCurrencyApiUrl}${remainingPath}`, config)).data;
  } catch (error) {
    return Promise.reject(error);
  }
};
